import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, Pipe, Inject } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';
import { BaseDataService } from 'src/app/core/services';
import { inConfig } from '../../../../features/in/in.config';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IndashboardService } from 'src/app/features/in/dashboard/indashboard.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  // imports: [CommonModule,SharedModule],
  selector: 'app-modal-close',
  templateUrl: './modal-close.component.html',
})
export class ModalCloseComponent implements OnInit {
  psDateFormat: any;
  private serverPath = inConfig.url.apiUrl + 'psuserdashboard';
  @ViewChild("modalContainer", { static: true, read: ViewContainerRef }) container;

  public numberPrecision;

  // @Input()
  data: any = {};

  // @Input()
  // modalShow: boolean = true;


  // @Input()
  // detailsObj;

  // @Output()
  // actionController$: EventEmitter<any> = new EventEmitter<any>();

 


  constructor(
    public langService: LangService,
    public apiService: BaseDataService,
    private utilityService: UtilityService,
    public inDashboardService: IndashboardService,
    public dataLoadService: DataLoadService,
    public toastrService: ToastrService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) data: any,
    private matDialogRef: MatDialogRef<any>
  ) {
    this.data = data;
    this.psDateFormat = globalVariables.psDateFormat;
    this.numberPrecision = globalVariables.numberPrecision;

  }
  ngOnInit() {
  }

  onClickClose() {
    this.matDialogRef.close();
  }


}
